export default __webpack_public_path__ + "static/media/icon-plus.76bf9a75.svg";